export default {"src":"/_next/static/media/rightArrowWhite.6d1999d4.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};